import {DiWordpress, DiCss3,DiPhp,DiReact,DiMysql,DiJavascript1} from "react-icons/di"
import {AiFillHtml5,AiOutlineFileSearch,AiFillShop} from "react-icons/ai"
import {SiJquery,SiTailwindcss} from "react-icons/si"
import {MdOutlineIntegrationInstructions} from "react-icons/md"


export default [
    {
        skill:"WordPress",
        icon: <DiWordpress/>,
        percent: 87
    },
    {
        skill:"HTML/HTML5",
        icon: <AiFillHtml5/>,
        percent: 90
    },
    {
        skill:"CSS/CSS3",
        icon: <DiCss3/>,
        percent: 90
    },
    {
        skill:"PHP",
        icon: <DiPhp/>,
        percent: 62
    },
    {
        skill:"jQuery",
        icon: <SiJquery/>,
        percent: 55
    },
    {
        skill:"Javascript",
        icon: <DiJavascript1/>,
        percent: 60
    },
    {
        skill:"Tailwindcss",
        icon: <SiTailwindcss/>,
        percent: 20
    },
    {
        skill:"React Js",
        icon: <DiReact/>,
        percent: 20
    },
    {
        skill:"MySQL",
        icon: <DiMysql/>,
        percent: 58
    },
    {
        skill:"CRM",
        icon: <MdOutlineIntegrationInstructions/>,
        percent: 67
    },
    {
        skill:"SEO",
        icon: <AiOutlineFileSearch/>,
        percent: 66
    },
    {
        skill:"E-Commerce",
        icon: <AiFillShop/>,
        percent: 84
    },
]